<template>
	<div class="pt-2">
		<CommonFlame :title="title">
			<v-row class="mt-2" no-gutters justify="space-between">
				<v-sheet elevation="0" width="300px">
					<v-select
						label="機能で絞り込む"
						v-model="feature"
						:items="features"
						item-text="name"
						item-value="id"
						dense
						outlined
						hide-details
						@change="filterFiles"
					/>
				</v-sheet>

				<DeletedAttachedFilesDialog :files="deleted_files" />
			</v-row>
			<div class="table-container mt-4">
				<v-data-table
					locale="ja-JP"
					:items="filterFiles"
					:headers="headers"
					:mobile-breakpoint="240"
					hide-default-footer
					disable-filtering
					disable-pagination
					disable-sort
					no-data-text="データがありません。"
				>
					<template v-slot:item="{ item }">
						<tr class="no-click">
							<td>
								<!-- TODO:機能が何か確認 -->
								{{ item.feature.name }}
							</td>
							<td>{{ item.tags }}</td>
							<td>{{ item.document_number }}</td>
							<td>
								<a :href="item.url" target="_blank">
									{{ item.name }}
								</a>
							</td>
							<td>
								<v-btn @click="openDeleteDialog(item)" icon>
									<v-icon>mdi-delete</v-icon>
								</v-btn>
							</td>
						</tr>
					</template>
				</v-data-table>
			</div>
		</CommonFlame>
		<AttachedFileDeleteDialog :dialog.sync="deleteDialog" :attachedFile="selectedFile" />
	</div>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import common from "../../helper/common"
import CommonFlame from "../shared/CommonFlame.vue"
import DeletedAttachedFilesDialog from "./components/DeletedAttachedFilesDialog.vue"
import AttachedFileDeleteDialog from "./components/AttachedFileDeleteDialog.vue"

export default {
	components: {
		CommonFlame,
		DeletedAttachedFilesDialog,
		AttachedFileDeleteDialog,
	},
	data() {
		return {
			title: "添付ファイル一覧",
			id: this.$route.params.id,
			targetType: this.$route.params.type_id,
			attached_files: [],
			deleted_files: [],
			features: [],
			feature: null,
			headers: headers(),
			deleteDialog: false,
			selectedFile: null,
			common,
		}
	},

	mounted() {
		this.fetchAttachedFiles()
	},
	methods: {
		fetchAttachedFiles() {
			const headers = authenticate.setHeader()
			const params = { target_type: this.targetType }
			const url = `/erp/v1/attached_files/targets/${this.id}`
			axios
				.get(url, {
					params,
					headers,
				})
				.then((res) => {
					res.data.attached_files = [
						{
							feature: { name: "XXXX" },
							tags: "XXX, XXX",
							document_number: "2023XXXX",
							url: "XXXXX",
							name: "XXXX.pdf",
							destroy_flag: false,
						},
						{
							feature: { name: "XXXX" },
							tags: "XXX, XXX",
							document_number: "2023XXXX",
							url: "XXXXX",
							name: "XXXX.jpeg",
							destroy_flag: false,
						},
						{
							feature: { name: "XXXX" },
							tags: "XXX, XXX",
							document_number: "2023XXXX",
							url: "XXXXX",
							name: "XXXX.jpeg",
							destroy_flag: false,
						},
						{
							feature: { name: "XXXX" },
							tags: "XXX, XXX",
							document_number: "2023XXXX",
							url: "XXXXX",
							name: "XXXX.pdf",
							destroy_flag: false,
						},
						{
							feature: { name: "XXXX" },
							tags: "XXX, XXX",
							document_number: "2023XXXX",
							url: "XXXXX",
							name: "XXXX.jpeg",
							destroy_flag: false,
						},
						{
							feature: { name: "XXXX" },
							tags: "XXX, XXX",
							document_number: "2023XXXX",
							url: "XXXXX",
							name: "XXXX.jpeg",
							destroy_flag: true,
							destroy_user: {full_name:"XX XX"},
							reason:"データ変更のため",
							destroy_date: "2023-05-01"
						},
					]
					this.attached_files = res.data.attached_files.filter((f) => f.destroy_flag == false)
					this.deleted_files = res.data.attached_files.filter((f) => f.destroy_flag == true)
					this.features = res.data.features
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		openDeleteDialog(file) {
			this.selectedFile = file
			this.deleteDialog = true
		},
		searchAttachedFiles(q) {
			this.q = q
			this.fetchAttachedFiles(q)
			this.$router.push({
				name: this.$route.name,
				query: { ...this.q },
			})
		},
		setQuery() {
			const query = this.$route.query
			let q = this.q
			Object.keys(this.$route.query).forEach((query_key) => {
				if (query[query_key] && query_key != "page" && query_key != "targetType") {
					q[query_key] = this.formatQuery(query[query_key])
				}
			})
			this.q = q
		},
		formatQuery(query) {
			if (query instanceof Array) {
				return query.map((v) => (isFinite(v) ? Number(v) : v))
			} else if (isFinite(query)) {
				return Number(query)
			} else {
				return query
			}
		},
	},
	computed: {
		filterFiles() {
			if (this.feature) {
				return this.attached_files.filter((f) => f.feature.id == this.feature.id)
			} else {
				return this.attached_files
			}
		},
	},
}

function headers() {
	return [
		{ text: "添付した機能", value: "feature.name", width: "150px" },
		{ text: "タグ", value: "tags", width: "200px" },
		{ text: "図書番号", value: "document_number", width: "120px" },
		{ text: "ファイル名", value: "name", width: "120px" },
		{ text: "", value: "", width: "80px" },
	]
}
</script>
